import { useContext, useEffect, useState } from 'react';
import { CircularProgress, FormLabel, Grid, IconButton, InputLabel, Tooltip } from '@material-ui/core';
import { Backup, Mail, Visibility } from '@material-ui/icons';
import { AppSelect, Dialogs, PrimaryButton, TextBox } from '../../../../Core/FormInput';
import { uploadOcrDoc } from '../../../../Core/Service/workflowJobDocument-service';
import { saveDynamicFormFieldUploadDoc } from '../../../../Core/Service/dynamic-forms-service';
import AppContext from '../../../../App/AppContext';
import { useHistory } from 'react-router-dom';
import DynamicAppSelect from './dynamicAppSelect';
import { getWorkflowStepList } from '../../../../Core/Service/workflowList-service';
import { ScreenContext } from './DynamicFormProvider';
import { CustomeSignPad } from '../../../../Core/SignaturePad';
import { useCallback } from 'react';
import doc from '../doc.png';
import '../workflow-job.scss';
// import DialogComp from '../../../../Core/Modal/dialogModal';
import MailDocModal from '../more/MailDoc';
import DialogComp from '../../../../Core/Controls/Dialog/DialogComp';
import { makeStyles } from '@material-ui/core/styles';
import { useWindowSize } from '../../../../Core/Controls/ScreenResolution';

const useStyles = makeStyles({
    inputContainerBackgroundColor: {
        backgroundColor: (props) => `${props.backgroundColor}`
    },
    inputContainerTextColor: {
        color: (props) => `${props.textColor}`
    }
});

const DynamicFormFields = ({ step, jobId, onDropdownChange, dropdownValue, fieldLabel, downloadDocument }) => {
    const [WindowWidths, WindowHeights] = useWindowSize();

    const classes = useStyles({ backgroundColor: step.backgroundColor, textColor: step.textColor });
    const [uploading, setUploading] = useState(false);
    const [showFieldImage, setShowFieldImage] = useState(false);
    const { showToast } = useContext(AppContext);
    const { showMail, state, getListOptionById, setDocumentWithOcrDocId, getDocumentFromOcrDocId, updateState, dynamicFormData } =
        useContext(ScreenContext);
    const ocrDoc = getDocumentFromOcrDocId(step.ocrDocumentId);

    const ops = step.listId && getListOptionById(step.listId);

    const GetTechnicianSign = (name, val) => {
        onDropdownChange({ [name]: val[name] });
    };

    const clearSig = (name) => {
        onDropdownChange && onDropdownChange({ [name]: '' });
    };

    // Fields without an ocrDocumentId keep their image in the form's own data,
    // under a sibling column named `<jsonPropertyName>Image`.
    const fieldImageKey = `${step.jsonPropertyName}Image`;
    const fieldImageValue = dynamicFormData?.tempMergedData?.[fieldImageKey];
    // The picker accepts images AND pdf, so the preview has to switch renderer.
    const isFieldImagePdf =
        typeof fieldImageValue === 'string' && (fieldImageValue.startsWith('data:application/pdf') || /\.pdf(\?|#|$)/i.test(fieldImageValue));

    // The image value itself is written into the sibling column
    // (e.g. DyamicForm_1 -> DyamicForm_1Image) and saved with the rest of the
    // dynamic form data, exactly like the signature field (displayType 7) does.
    const uploadFieldImage = (e) => {
        const input = e.target;
        const file = input.files && input.files[0];
        if (!file) return;

        setUploading(true);
        const reader = new FileReader();
        reader.onloadend = () => {
            onDropdownChange && onDropdownChange({ [fieldImageKey]: reader.result });
            setUploading(false);
            // Reset so re-selecting the same file still fires onChange
            input.value = '';
        };
        reader.onerror = () => {
            setUploading(false);
            showToast('Could not read the selected file.');
            input.value = '';
        };
        reader.readAsDataURL(file);
    };

    const viewFieldImage = () => {
        if (!fieldImageValue) return;
        setShowFieldImage(true);
    };

    const clearFieldImage = () => {
        onDropdownChange && onDropdownChange({ [fieldImageKey]: '' });
        setShowFieldImage(false);
    };

    // Inline upload for a dynamic form field. Mirrors uploadFiles() in renderForm.jsx
    // (the document viewer) so both entry points hit the same endpoint and refresh
    // the field's document the same way.
    const uploadDynamicDoc = async (e) => {
        if (!e.target.files || !e.target.files.length) return;

        const formData = new FormData();
        for (let i = 0; i < e.target.files.length; i++) {
            formData.append(e.target.files[i].name, e.target.files[i]);
        }

        setUploading(true);
        try {
            const res = await saveDynamicFormFieldUploadDoc(jobId, step.fieldId, formData);
            if (res.success) {
                downloadDocument(jobId, step.fieldId);
                showToast('File Uploaded successfully.');
            } else {
                showToast(res.message || 'Upload failed.');
            }
        } catch (err) {
            console.error('Dynamic form field upload failed:', err);
            showToast('Upload failed.');
        } finally {
            setUploading(false);
            // Reset so selecting the same file again still fires onChange
            e.target.value = '';
        }
    };

    const docAction = (actionType) => {
        switch (actionType) {
            case 'VIEW':
                // downloadDocument(step.ocrDocumentId, ocrDoc.docName);
                downloadDocument(jobId, step.fieldId);
                updateState({ showDoc: true, selectedFieldData: { fieldId: step.fieldId, showUpload: step.showUpload, isDeleted: step.isDeleted } });
                break;
            case 'MAIL':
                showMail({ ocrDocumentName: step.ocrDocumentName, docName: ocrDoc.docName || '', ocrDocIdToMail: step.ocrDocumentId });
                break;
            default:
                showToast(`Event Type: ${actionType} is not implement yet.`);
        }
    };

    const getLink = (URL) => {
        if (!URL.includes('youtube.com')) {
            return URL;
        }
        if (URL.includes('youtube.com') && !URL.includes('/embed/')) {
            return 'https://www.youtube.com/embed/' + URL.split('?v=')[1];
        }
        return URL;
    };

    const getDocumentAction = () => {
        if (step.ocrDocumentId) {
            return (
                <>
                    {step.showUpload && (
                        <label title="Upload Document">
                            <IconButton color="secondary" component="span" style={{ padding: '0px 3px' }}>
                                <Backup />
                                <input
                                    type="file"
                                    onChange={(e) => uploadDynamicDoc(e)}
                                    className="upload-btn-input-file"
                                    style={{ display: 'none' }}
                                    accept="image/*,application/pdf"
                                />
                                {uploading && <CircularProgress size={40} className="upload-progress" color="secondary" />}
                            </IconButton>
                        </label>
                    )}
                    {step.showView && (
                        <label title="Upload Documents">
                            <IconButton
                                color={state.currentVisibleDocName === ocrDoc?.docName ? 'primary' : 'secondary'}
                                component="span"
                                onClick={() => docAction('VIEW')}
                                style={{ padding: '0px 3px' }}
                            >
                                <Backup />
                            </IconButton>
                        </label>
                    )}
                    {/* {step.showEmail && (
                        <label title="Email Document">
                            <IconButton style={{ padding: '0px 0px 0px 3px' }} color="secondary" component="span" onClick={() => docAction('MAIL')}>
                                <Mail />
                            </IconButton>
                        </label>
                    )} */}
                </>
            );
        } else {
            // Fields with no ocrDocumentId store their image against the form's own
            // data column: `${jsonPropertyName}Image`. The upload posts that column
            // name in the payload, and the view icon appears once the API has
            // returned a value for it.
            return (
                <>
                    {step.showUpload && (
                        <label title="Upload Image or PDF">
                            <IconButton color="secondary" component="span" style={{ padding: '0px 3px' }}>
                                <Backup />
                                <input
                                    type="file"
                                    onChange={(e) => uploadFieldImage(e)}
                                    className="upload-btn-input-file"
                                    style={{ display: 'none' }}
                                    accept="image/*,application/pdf"
                                />
                                {uploading && <CircularProgress size={40} className="upload-progress" color="secondary" />}
                            </IconButton>
                        </label>
                    )}
                    {fieldImageValue && (
                        <label title="View Attachment">
                            <IconButton color="secondary" component="span" onClick={viewFieldImage} style={{ padding: '0px 3px' }}>
                                <Visibility />
                            </IconButton>
                        </label>
                    )}
                </>
            );
        }
    };

    return (
        <Grid container spacing={2} justifyContent="center">
            {step.displayType != 7 && (
                <Grid item xs={12} className={classes.inputContainerBackgroundColor}>
                    <Grid container justifyContent="space-between">
                        <FormLabel
                            required={step.isRequired ? true : false}
                            component="legend"
                            className={step.isRequired ? `mandatoryfields ${classes.inputContainerTextColor}` : false}
                        >
                            {fieldLabel}
                        </FormLabel>
                        <FormLabel>{getDocumentAction()}</FormLabel>
                    </Grid>
                    {step.subtitle && (
                        <Grid container style={{ padding: '7px 0px 0px 0px' }}>
                            <Grid item xs={12}>
                                <InputLabel shrink className={classes.inputContainerTextColor}>
                                    {step.subtitle}
                                </InputLabel>
                            </Grid>
                        </Grid>
                    )}
                    {(step.dynamicFormFieldNotes || step.notes || step.DynamicFormFieldNotes || step.fieldNotes) && (
                        <Grid container style={{ padding: '7px 0px 0px 0px' }}>
                            <Grid item xs={12}>
                                <InputLabel shrink className={classes.inputContainerTextColor} style={{ whiteSpace: 'pre-wrap' }}>
                                    {step.dynamicFormFieldNotes || step.notes || step.DynamicFormFieldNotes || step.fieldNotes}
                                </InputLabel>
                            </Grid>
                        </Grid>
                    )}
                </Grid>
            )}
            {(step.textURL || step.textImage) && (
                <Grid item xs={12} className={classes.inputContainerBackgroundColor}>
                    <div style={{ position: 'relative', width: '100%', paddingTop: WindowWidths < 700 ? '100%' : '50%' }}>
                        {step.textImage && (
                            <div style={{ position: 'absolute', top: 0, left: 0, bottom: 0, right: 0, textAlign: 'center' }}>
                                <img
                                    src={step.textImage}
                                    style={{
                                        height: '100%',
                                        width: '100%'
                                    }}
                                />
                            </div>
                        )}
                        {step.textURL && (
                            <div style={{ position: 'absolute', top: 0, left: 0, bottom: 0, right: 0, textAlign: 'center' }}>
                                <iframe
                                    frameborder="0"
                                    allowFullScreen="true"
                                    webkitallowfullscreen="true"
                                    mozallowfullscreen="true"
                                    width="100%"
                                    height="100%"
                                    src={getLink(step.textURL)}
                                />
                            </div>
                        )}
                    </div>
                </Grid>
            )}
            <Grid item xs={12} className={classes.inputContainerBackgroundColor}>
                {step.displayType == 5 || step.displayType == 6 || step.displayType == 8 || step.displayType == 9 ? (
                    <>
                        <TextBox
                            size="small"
                            type={step.displayType == 8 ? 'datetime-local' : step.displayType == 9 ? 'number' : 'text'}
                            name={step.jsonPropertyName}
                            value={dropdownValue}
                            multiline={step.displayType == 6 ? true : false}
                            rows={step.numberOfRows || 1}
                            color="primary"
                            onChange={(e) => onDropdownChange({ [step.jsonPropertyName]: e.target.value })}
                        />
                    </>
                ) : step.displayType == 1 || step.displayType == 4 || step.displayType == 2 || step.displayType == 3 ? (
                    <DynamicAppSelect
                        displayType={step.displayType}
                        name={step.jsonPropertyName}
                        value={dropdownValue}
                        onChange={onDropdownChange}
                        options={ops}
                        valuePropertyName="listOptionId"
                        textPropertyName="listOptionName"
                    />
                ) : step.displayType == 7 ? (
                    <CustomeSignPad
                        onChange={(val) => GetTechnicianSign(step.jsonPropertyName, val)}
                        content={fieldLabel}
                        value={dropdownValue}
                        name={step.jsonPropertyName}
                        sign={dropdownValue}
                        clearSig={() => clearSig(step.jsonPropertyName)}
                        isRequired={step.isRequired}
                    />
                ) : null}
            </Grid>

            {showFieldImage && (
                <DialogComp title={step.fieldLabel || 'Attachment'} maxWidth="md" fullWidth onClose={() => setShowFieldImage(false)}>
                    <Grid container spacing={2} justifyContent="center">
                        <Grid item xs={12} style={{ textAlign: 'center' }}>
                            {isFieldImagePdf ? (
                                <iframe src={fieldImageValue} title={step.fieldLabel || 'Uploaded document'} style={{ width: '100%', height: '70vh', border: 0 }} />
                            ) : (
                                <img src={fieldImageValue} alt={step.fieldLabel || 'Uploaded image'} style={{ maxWidth: '100%', maxHeight: '70vh' }} />
                            )}
                        </Grid>
                        <Grid item>
                            <PrimaryButton onClick={clearFieldImage}>Remove Attachment</PrimaryButton>
                        </Grid>
                    </Grid>
                </DialogComp>
            )}
        </Grid>
    );
};

export default DynamicFormFields;
